//lbaTimeZoneSelect

const lbaTimeZoneSelect = angular.module('app.lbaTimeZoneSelect', []);

lbaTimeZoneSelect.controller('lbaTimeZoneSelectCtrl', require('./lbaTimeZoneSelectCtrl'));
lbaTimeZoneSelect.directive('lbaTimeZoneSelect', require('./lbaTimeZoneSelectDir'));
lbaTimeZoneSelect.service('timeZoneService', require('../../services/timeZoneService'));

export default lbaTimeZoneSelect;



// WEBPACK FOOTER //
// ./src/components/lbaTimeZoneSelect/index.js